import { newCheckerActions } from "./Action";

const initialState = {
  newScannedCheckerOrderDetailsSuccess: null,
  newScannedCheckerOrderError: null,
  checkerMissingMeds: null,
  checkerMissingMedsError: null,
  mrpError: null,
  qtyError: null,
  checkInvoice: null,
  checkInvoiceError: null,
  createInvoiceError: null,
  deleteInvoiceError: null,
  allMedDetails: null,
  allMedDetailsError: null,
  deskError: null,
  invoiceDetails: null,
  invoiceDetailsError: null,
  deskDetails: null,
  deskDetailsError: null,
  enableDisableError: null,
  allBatchDetails: null,
  allBatchDetailsError: null,
  elasticMedDetails: null,
  elasticMedDetailsError: null,
  itemStockDetails: null,
  itemStockDetailsError: null,
  addMedicineError: null,
  orderSummaryDetails: null,
  orderSummaryError: null,
  urlSuccess: null,
  urlFailure: null,
};

export const newCheckerOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case newCheckerActions.CLEAR_CHECKER_ORDER_DATA:
      return {
        ...state,
        newPickerOrderDetailsSuccess: null,
        newPickerOrderError: null,
        newScannedCheckerOrderDetailsSuccess: null,
        newScannedCheckerOrderError: null,
      };

    case newCheckerActions.FETCH_SCANNED_CHECKER_ORDER_DATA_SUCCESS:
      return {
        ...state,
        newScannedCheckerOrderDetailsSuccess: action.payload,
        newScannedCheckerOrderError: null,
      };

    case newCheckerActions.FETCH_SCANNED_CHECKER_ORDER_DATA_FAILURE:
      return {
        ...state,
        newScannedCheckerOrderDetailsSuccess: null,
        newScannedCheckerOrderError: action.payload,
      };

    case newCheckerActions.FETCH_DESK_DETAILS_SUCCESS:
      return {
        ...state,
        deskDetails: action.payload,
        deskDetailsError: null,
      };

    case newCheckerActions.FETCH_DESK_DETAILS_FAILURE:
      return {
        ...state,
        deskDetails: null,
        deskDetailsError: action.payload,
      };

    case newCheckerActions.SAVE_MISSING_MEDS_SUCCESS:
      return {
        ...state,
        checkerMissingMeds: action.payload,
        checkerMissingMedsError: null,
      };

    case newCheckerActions.SAVE_MISSING_MEDS_FAILURE:
      return {
        ...state,
        checkerMissingMeds: null,
        checkerMissingMedsError: action.payload,
      };

    case newCheckerActions.EDIT_MRP_SUCCESS:
      return {
        ...state,
        mrpError: null,
      };

    case newCheckerActions.EDIT_MRP_ERROR:
      return {
        ...state,
        mrpError: action.payload,
      };

    case newCheckerActions.SET_QTY_SUCCESS:
      return {
        ...state,
        qtyError: null,
      };

    case newCheckerActions.SET_QTY_FAILURE:
      return {
        ...state,
        qtyError: action.payload,
      };

    case newCheckerActions.CHECK_INVOICE_EXISTS_SUCCESS:
      return {
        ...state,
        checkInvoice: action.payload,
        checkInvoiceError: null,
      };

    case newCheckerActions.CHECK_INVOICE_EXISTS_FAILURE:
      return {
        ...state,
        checkInvoice: null,
        checkInvoiceError: action.payload,
      };

    case newCheckerActions.CREATE_INVOICE_SUCCESS:
      return {
        ...state,
        createInvoiceError: null,
      };

    case newCheckerActions.CREATE_INVOICE_ERROR:
      return {
        ...state,
        createInvoiceError: action.payload,
      };

    case newCheckerActions.DELETE_INVOICE_SUCCESS:
      return {
        ...state,
        deleteInvoiceError: null,
      };

    case newCheckerActions.DELETE_INVOICE_FAILURE:
      return {
        ...state,
        deleteInvoiceError: action.payload,
      };

    case newCheckerActions.GET_MED_DETAILS_SUCCESS:
      return {
        ...state,
        allMedDetails: action.payload,
        allMedDetailsError: null,
      };

    case newCheckerActions.GET_MED_DETAILS_FAILURE:
      return {
        ...state,
        allMedDetails: null,
        allMedDetailsError: action.payload,
      };

    case newCheckerActions.ADD_OR_UPDATE_DESK_NUMBER_SUCCESS:
      return {
        ...state,
        deskError: null,
      };

    case newCheckerActions.ADD_OR_UPDATE_DESK_NUMBER_FAILURE:
      return {
        ...state,
        deskError: action.payload,
      };

    case newCheckerActions.GENERATE_INVOICE_SUCCESS:
      return {
        ...state,
        invoiceDetails: action.payload,
        invoiceDetailsError: null,
      };

    case newCheckerActions.GENERATE_INVOICE_ERROR:
      return {
        ...state,
        invoiceDetails: null,
        invoiceDetailsError: action.payload,
      };

    case newCheckerActions.ENABLE_DISABLE_MEDS_SUCCESS:
      return {
        ...state,
        enableDisableError: null,
      };

    case newCheckerActions.ENABLE_DISABLE_MEDS_FAILURE:
      return {
        ...state,
        enableDisableError: action.payload,
      };

    case newCheckerActions.GET_ORDER_ITEM_BATCHES_FROM_NETSUITE_SUCCESS:
      return {
        ...state,
        allBatchDetails: action.payload,
        allBatchDetailsError: null,
      };

    case newCheckerActions.GET_ORDER_ITEM_BATCHES_FROM_NETSUITE_FAILURE:
      return {
        ...state,
        allBatchDetails: null,
        allBatchDetailsError: action.payload,
      };

    case newCheckerActions.FETCH_FROM_ELASTIC_SEARCH_SUCCESS:
      return {
        ...state,
        elasticMedDetails: action.payload,
        elasticMedDetailsError: null,
      };

    case newCheckerActions.FETCH_FROM_ELASTIC_SEARCH_FAILURE:
      return {
        ...state,
        elasticMedDetails: null,
        elasticMedDetailsError: action.payload,
      };

    case newCheckerActions.GET_ITEM_AVAILABLE_STOCK_SUCCESS:
      return {
        ...state,
        itemStockDetails: action.payload,
        itemStockDetailsError: null,
      };

    case newCheckerActions.GET_ITEM_AVAILABLE_STOCK_FAILURE:
      return {
        ...state,
        itemStockDetails: null,
        itemStockDetailsError: action.payload,
      };

    case newCheckerActions.ADD_MEDICINE_SUCCESS:
      return {
        ...state,
        addMedicineError: null,
      };

    case newCheckerActions.ADD_MEDICINE_FAILURE:
      return {
        ...state,
        addMedicineError: action.payload,
      };

    case newCheckerActions.FETCH_ORDER_SUMMARY_DATA_SUCCESS:
      return {
        ...state,
        orderSummaryDetails: action.payload,
        orderSummaryError: null,
      };

    case newCheckerActions.FETCH_ORDER_SUMMARY_DATA_FAILURE:
      return {
        ...state,
        orderSummaryDetails: null,
        orderSummaryError: action.payload,
      };

    case newCheckerActions.CHECK_URL_SUCCESS:
      return {
        ...state,
        urlSuccess: action.payload,
        urlFailure: null,
      };

    case newCheckerActions.CHECK_URL_FAILURE:
      return {
        ...state,
        urlSuccess: null,
        urlFailure: action.payload,
      };

    default:
      return state;
  }
};
